<!--ABOUTME: One-time notice shown to users about the MyStekz -> Gotoko rebrand-->
<!--ABOUTME: Used with PrimeVue useDialog, opened by useRebrandNotice-->

<template>
    <div class="rebrand-notice">
        <GotokoLogo class="rebrand-notice__logo" />
        <p class="rebrand-notice__body">
            MyStekz is now <strong>Gotoko</strong>. Same product, same team,
            same account — just a new name and a new home at
            <strong>gotoko.ai</strong>. You may need to sign in again after the
            move; update your bookmarks and you're all set.
        </p>
        <div class="rebrand-notice__actions">
            <Button
                label="Got it"
                icon="pi pi-check"
                @click="handleClose"
                autofocus
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import { Ref, inject } from "vue";

import GotokoLogo from "@/components/GotokoLogo.vue";

const dialogRef = inject<Ref<DynamicDialogInstance> | undefined>("dialogRef");

const handleClose = () => {
    dialogRef?.value.close();
};
</script>

<style lang="scss" scoped>
.rebrand-notice {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 1rem;

    &__logo {
        height: 40px;
        width: auto;
        margin-bottom: 0.5rem;
    }

    &__body {
        color: var(--text-color);
        line-height: 1.6;
        font-size: 1rem;
        margin: 0;
    }

    &__actions {
        margin-top: 1rem;
        padding-top: 1rem;
        border-top: 1px solid var(--surface-border);
        width: 100%;
        display: flex;
        justify-content: center;
    }
}
</style>
